import { Controller } from "@hotwired/stimulus"

// Automatically submits a form when any input inside it changes.
// Usage: data-controller="auto-submit" on the form element.
// Change events bubble from checkboxes/selects up to the form.
export default class extends Controller {
  submit() {
    this.element.requestSubmit()
  }
}
